export default function roundUpToTheNearestSecond(timeInMillis: number): number {
  const delta = timeInMillis % 1000
  return delta ? timeInMillis - delta + 1000 : timeInMillis
}
